var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-wrapper fixed bottom-0 left-0 w-full right-0 z-100 bg-white"},[_c('button',{staticClass:"mx-auto table text-error",attrs:{"type":"button"},on:{"click":_vm.logOut}},[_vm._v(_vm._s(_vm.$t('Log Out')))])])}
var staticRenderFns = []

export { render, staticRenderFns }